module.exports = __webpack_public_path__ + "images/bannerFR-b3de9ed3446c485775f7473e87278d9c.jpg";